import React from "react";
import VDBText from "@components/atoms/Text";
import { Spacer } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTheme } from "styled-components/native";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useTranslation } from "react-i18next";
import styled from "styled-components/native";
import { useDefaultSearchGroup } from "../../../../hooks/useDefaultSearchGroup";
import LayoutContainer from "@components/layout/LayoutContainer";
import { useState } from "react";
import ProductSearchGroupScreen from "./ProductSearchGroupScreen";
import { useOtherSearchGroupSlice } from "@redux/slices/otherSearchGroups";

const ProductSearchGroupParentScreenWeb = () => {
  const theme = useTheme();
  const typography = useTypographyStore();
  const { t } = useTranslation();
  const updatedSection = useDefaultSearchGroup();
  const { otherGroups } = useOtherSearchGroupSlice();
  const scenes = {};
  updatedSection[0]?.data.forEach((sectionData, index) => {
    scenes[sectionData?.key] = () => (
      <ProductSearchGroupScreen
        key={index}
        searchGroupsData={otherGroups[sectionData?.key]}
        productType={sectionData?.key}
      />
    );
  });

  const tabOptions = updatedSection[0]?.data.map((item) => {
    return {
      key: item.key,
      title: item.itemLeftText,
    };
  });
  const activeIndex = tabOptions?.findIndex(
    (item: any) => otherGroups?.[item?.key]?.[0] !== 0
  );

  const [activeTabIndex, setActiveTabIndex] = useState(
    activeIndex > -1 ? activeIndex : 0
  );

  return (
    <>
      <LayoutContainer>
        <Overlay>
          <TextContainer>
            <VDBText type={typography["H1-B"]} color={theme["core-05"]}>
              {t("searchGroup.webHeader.title.text")}
            </VDBText>
            <Spacer size={SpaceType.Basic} />
            <VDBText type={typography["Body-R"]} color={theme["core-05"]}>
              {t("searchGroup.webHeader.subTitle.text")}
            </VDBText>
          </TextContainer>
          <TabsContainer horizontal={true}>
            {tabOptions.map((option, index) => {
              return (
                <TabButton
                  key={index}
                  onPress={() => setActiveTabIndex(index)}
                  isActive={index === activeTabIndex}
                >
                  <TabButtonText>
                    <VDBText
                      type={
                        typography[index === activeTabIndex ? "H2-M" : "H2-R"]
                      }
                      color={
                        theme[index === activeTabIndex ? "core-05" : "core-06"]
                      }
                    >
                      {option.title}
                    </VDBText>
                  </TabButtonText>
                  <TabButtonBottomBorder isActive={index === activeTabIndex} />
                </TabButton>
              );
            })}
          </TabsContainer>
          <TabContentView>
            {scenes[tabOptions[activeTabIndex].key]()}
          </TabContentView>
        </Overlay>
      </LayoutContainer>
    </>
  );
};

const Overlay = styled.View`
  min-width: 400px;
`;

const TextContainer = styled.View`
  margin: ${SpaceType.Double}px;
`;

const TabButton = styled.TouchableOpacity<{
  isActive: boolean;
}>``;

const TabButtonText = styled.View`
  padding: ${SpaceType.Double}px ${SpaceType.Double}px 10px;
`;

const TabButtonBottomBorder = styled.View<{
  isActive: boolean;
}>`
  background-color: ${({ isActive, theme }) =>
    isActive ? theme["extra-02"] : "transparent"};
  width: 100%;
  height: 4px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
`;

const TabsContainer = styled.ScrollView`
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }) => theme["core-03"]};
`;

const TabContentView = styled.View`
  min-height: 260px;
`;

export default ProductSearchGroupParentScreenWeb;
